import React from "react";
import { useNavigate } from "react-router-dom";

import { Button, Title } from "~/components";
import { ROUTES } from "~/router";
import AuthBanner, { BannerTypes } from "~/screens/Auth/components/AuthBanner";
import { AuthLayout } from "~/screens/Auth/Layout/AuthLayout";
import { usePageTitle } from "~/shared";

export const NotFound = () => {
  usePageTitle("Not found");
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(ROUTES.fullLogin);
  };
  return (
    <AuthLayout banner={<AuthBanner type={BannerTypes.notFound} />} showSupport>
      <section className="flex w-full items-center justify-center pb-8">
        <div className="w-full max-w-lg bg-white py-2">
          <section className="space-y-6">
            <Title>Oops! Looks like we can’t find that page.</Title>
            <p className="text-indigo mb-3 font-medium">
              But there’s tons more where that came from. Click below to
              discover more menopause education and resources.
            </p>
          </section>

          <section className="mt-20">
            <Button
              size="default"
              className="w-full md:w-auto"
              onClick={handleClick}
            >
              Back to homepage
            </Button>
          </section>
        </div>
      </section>
    </AuthLayout>
  );
};
